import FuseUtils from '@fuse/utils';
import { Navigate } from 'react-router-dom';
import settingsConfig from 'app/configs/settingsConfig';
import ExampleConfig from '../main/example/ExampleConfig';
import ChatsConfig from '../main/messenger/ChatsPageConfig';
import { FuseRouteConfigsType, FuseRoutesType } from '@fuse/utils/FuseUtils';

const routeConfigs: FuseRouteConfigsType = [ExampleConfig, ChatsConfig];

/**
 * The routes of the application.
 */
const routes: FuseRoutesType = [
	ChatsConfig,
	...FuseUtils.generateRoutesFromConfigs(routeConfigs, []),
	{
		path: '/',
		element: <Navigate to="/chat" replace={true} />,
		auth: settingsConfig.defaultAuth
	},
	{
		path: '/chat',
		element: <Navigate to="/chat" />,
	}
];

export default routes;
